
import Vue from "vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import LargeSelect from "~/components/form/LargeSelect.vue";
import SmallRoundedSelect from "~/components/form/SmallRoundedSelect.vue";
import BoxCaseForm from "~/components/ship/BoxCaseForm.vue";
import StageForm from "~/components/ship/StageForm.vue";
import Contents from "~/components/ship/steps/Contents.vue";
import Costs from "~/components/ship/steps/Costs.vue";
import Details from "~/components/ship/steps/Details.vue";
import Payment from "~/components/ship/steps/Payment.vue";
import Search from "~/components/ship/steps/Search.vue";

export default Vue.extend({
  name: "ShipSteps",
  components: {
    SmallRoundedSelect,
    LargeSelect,
    StageForm,
    BoxCaseForm,
    Search,
    Costs,
    Details,
    Contents,
    Payment,
    LoaderSpinner,
  },
  data() {
    return {
      outShip: this.$route.name !== "ship" ? true : (false as boolean),
    };
  },
  computed: {
    // Vuex getters
    ...mapGetters({
      loading: "loading",
      stepNumber: "ship/stepNumber",
      stepName: "ship/stepName",
    }),
  },
  created() {
    this.flushShipStore("event"); // call payment flusher too
    this.flushPaymentStore("event");
  },
  methods: {
    ...mapMutations({
      setStepNumber: "ship/setStepNumber",
      setStepName: "ship/setStepName",
      setStep: "ship/setStep",
      setTrips: "ship/setTrips",
      flushShipStore: "ship/flush",
      flushPaymentStore: "payment/flush",
    }),
    ...mapActions({
      clearActiveNotices: "errorsBag/clearActiveNotices",
    }),
    changeStep(step) {
      if (step === "Search" || step === 1) {
        this.setStep({ id: 1, name: "Search" });
        this.setStepNumber(1);
        this.setStepName("Search");
      } else if (step === "Costs" || step === 2) {
        this.setStep({ id: 2, name: "Costs" });
        this.setStepNumber(2);
        this.setStepName("Costs");
      } else if (step === "Details" || step === 3) {
        this.setStep({ id: 3, name: "Details" });
        this.setStepNumber(3);
        this.setStepName("Details");
      } else if (step === "Contents" || step === 4) {
        this.setStep({ id: 4, name: "Contents" });
        this.setStepNumber(4);
        this.setStepName("Contents");
      } else if (step === "Payment" || step === 5) {
        this.setStep({ id: 5, name: "Payment" });
        this.setStepNumber(5);
        this.setStepName("Payment");
      }
    },
    goStep(stepName, valid) {
      if (valid) {
        this.changeStep(stepName);
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to && to.name !== "confirmation" && typeof window !== "undefined") {
      this.flushShipStore("event"); // call payment flusher too
      this.flushPaymentStore("event");
      this.clearActiveNotices();
    }
    next();
  },
});
